document.addEventListener('DOMContentLoaded', () => {

  // Contact
  function updateContactContainerVisibility() {
    var steps = document.querySelectorAll(".gform_page");
    var contactContainer = document.querySelector(".contact-container");

    if (!contactContainer) {
        return;
    }

    steps.forEach(function (step, index) {
        if (window.getComputedStyle(step).display !== "none") {
            var activeStep = index + 1;
            if (activeStep === 1) {
                contactContainer.classList.remove("contact-hide");
            } else {
                contactContainer.classList.add("contact-hide");
            }
        }
    });
  }

  updateContactContainerVisibility();

  var observer = new MutationObserver(function () {
      updateContactContainerVisibility();
  });

  var formContainer = document.querySelector(".gform_wrapper");
  if (formContainer) {
      observer.observe(formContainer, { attributes: true, childList: true, subtree: true });
  }
  // End Contact

  var header = document.querySelector(".site-header");
  var stickyElement = document.querySelector(".wp-block-group.is-position-sticky");

  var headerHeight = header.offsetHeight;
  
  if (header && stickyElement) {
      stickyElement.style.top = headerHeight + "px";
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('type')) {
      let checkExist = setInterval(() => {
          const contactSection = document.querySelector("#contact");
          if (contactSection) {
              clearInterval(checkExist);

              const elementPosition = contactSection.getBoundingClientRect().top + window.scrollY;
              const offsetPosition = elementPosition - headerHeight - 10;

              window.scrollTo({ top: offsetPosition, behavior: "smooth" });
          }
      }, 200);
  }

  // MENU
  function adjustMenuMinHeight() {
    let maxHeight = 0;

    const megaMenus = document.querySelectorAll('.mega-menu-extended-content');

    megaMenus.forEach(menu => {
        const originalDisplay = menu.style.display;

        menu.style.display = "block";
        menu.style.visibility = "hidden";

        const currentHeight = menu.getBoundingClientRect().height;
        if (currentHeight > maxHeight) {
            maxHeight = currentHeight;
        }

        menu.style.display = originalDisplay;
        menu.style.visibility = "";
    });

    document.querySelectorAll('.astra-megamenu').forEach(menu => {
        const computedStyle = window.getComputedStyle(menu);
        const paddingTop = parseFloat(computedStyle.paddingTop);
        const paddingBottom = parseFloat(computedStyle.paddingBottom);
        const totalMinHeight = maxHeight + paddingTop + paddingBottom;

        menu.style.minHeight = totalMinHeight ? `${totalMinHeight}px` : '';
    });
  }

  if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
          adjustMenuMinHeight();
      });

      document.querySelectorAll('.mega-menu-extended-content').forEach(menu => {
          resizeObserver.observe(menu);
      });
  }

  document.querySelectorAll('.astra-megamenu .menu-item-has-children').forEach(item => {
      item.addEventListener('mouseenter', adjustMenuMinHeight);
      item.addEventListener('mouseleave', adjustMenuMinHeight);
  });

  window.addEventListener('resize', adjustMenuMinHeight);
  // END MENU

  // MOBILE MENU
  var mobilePopup = document.getElementById('ast-mobile-popup');
  if (mobilePopup) {

    var header = document.querySelector('.ast-mobile-popup-header');
    var closeBtn = document.querySelector('#menu-toggle-close');

    var headerNav = document.querySelector('.ast-mobile-popup-drawer .ast-mobile-popup-header').offsetHeight;
    // document.querySelectorAll('#ast-hf-mobile-menu .sub-menu').forEach(function(el) {
    //   el.style.paddingTop = headerNav + 'px';
    // });

    // Create the back button if it doesn't already exist and prepend it
    var backBtn = document.querySelector('#menu-back-btn');
    if (!backBtn) {
      backBtn = document.createElement('button');
      backBtn.id = 'menu-back-btn';
      backBtn.classList.add('back-btn');
      backBtn.textContent = 'Vorige';
      backBtn.style.display = 'none';
      backBtn.classList.remove('active');
      header.prepend(backBtn);
    }

    function updateHeaderButtons() {
      var activeSubmenu = document.querySelector('#ast-hf-mobile-menu .sub-menu.active');
      if (activeSubmenu) {
        backBtn.classList.add('active');
      } else {
        backBtn.classList.remove('active');
      }
    }

    // Function to reset the mobile menu to level 1
    function resetMenuState() {
      document.querySelectorAll('#ast-hf-mobile-menu ul.sub-menu.active').forEach(function (submenu) {
        submenu.classList.remove('active');
        // submenu.style.display = 'none';
        var parentItem = submenu.parentElement;
        if (parentItem) {
          parentItem.classList.remove('open');
        }
      });
      updateHeaderButtons();
    }

    var parentLinks = document.querySelectorAll('#ast-hf-mobile-menu .menu-item-has-children > a');
    parentLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var parentItem = this.parentElement;
        var submenu = parentItem.querySelector('ul.sub-menu');
        if (submenu) {
          if (submenu.classList.contains('active')) {
            submenu.classList.remove('active');
            parentItem.classList.remove('open');
            submenu.style.display = 'none';
          } else {
            submenu.classList.add('active');
            parentItem.classList.add('open');
            submenu.style.display = 'block';
          }
        }
        updateHeaderButtons();
      }, true);
    });

    backBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var activeSubmenu = document.querySelector('#ast-hf-mobile-menu .sub-menu.active');
      if (activeSubmenu) {
        resetMenuState();
      } else {
        closeBtn.click();
      }
    });

    closeBtn.addEventListener('click', function () {
      setTimeout(resetMenuState, 300);
    });

    window.addEventListener('resize', updateHeaderButtons);

    resetMenuState();
  }
  // END MOBILE MENU

  document.querySelectorAll('.schema-faq-section').forEach(section => {
    section.querySelector('.schema-faq-question').addEventListener('click', () => {
      section.classList.toggle('is-open');
    });
  });

  initKeenSliders();
  initAnimations();

  let resizeTimeout;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        document.querySelectorAll('.keen-slider').forEach(el => {
            if (el.keenSlider) {
                el.keenSlider.update();
            }
        });
        // Indien condities (zoals slide count of extra class) veranderen, reinitializeer je alsnog:
        initKeenSliders();
    }, 300);
  })

  function initializeLocationField() {
    const locationField = document.querySelector('.location-input select');
    const formContainer = document.querySelector('.form-container');
    const contactBlock = document.querySelector('.wp-block-vandorp-contact');

    if (!locationField || !formContainer) return;

    const acfLocation = document.querySelector('[data-acf-location]');
    let initialLocationId = acfLocation ? acfLocation.dataset.acfLocation : '';

    if (initialLocationId) {
        fetchLocationDetails(initialLocationId);
        contactBlock.classList.add('wp-block-vandorp-contact--has-location');
    }

    locationField.addEventListener('change', function () {
        const locationId = this.value;
        if (locationId && locationId !== "Kies een vestiging") {
            contactBlock.classList.add('wp-block-vandorp-contact--has-location');
        } else {
            contactBlock.classList.remove('wp-block-vandorp-contact--has-location');
        }
        fetchLocationDetails(locationId);
    });
  }

  function fetchLocationDetails(locationId) {
    if (!locationId || locationId === "Kies een vestiging") {
        locationId = 0;
    }

    fetch(`/wp-json/vandorp/v1/contact_details/${locationId}`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`[API ERROR] HTTP ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        if (data && !data.code) {
            updateContactDetails(data);
            
            if (data.form_id) {
                updateGravityForm(data.form_id, locationId);
            }
        }
    })
  }


function updateContactDetails(data) {
    document.querySelector('.contact-container h3').textContent = data.title;
    document.querySelector('.contact-container p').textContent = data.function;
    document.querySelector('.contact-container .featured-image').style.backgroundImage = `url('${data.image}')`;

    const phoneButton = document.querySelector('.form-container .wp-phone-button a');
    if (phoneButton) {
        phoneButton.href = `tel:${data.phone || '#'}`;
        phoneButton.innerHTML = `<span class="icon-phone-solid"></span> Bel ${data.phonetitle || 'Van Dorp'}`;
    }

    const locationButton = document.querySelector('.form-container .wp-location-button a');
    if (locationButton) {
        locationButton.href = data.location_url;
    }
}

function updateGravityForm(formId, locationId) {
    const formContainer = document.querySelector('.form-container');
    if (!formContainer) return;

    formContainer.innerHTML = `<div class="loading-message">Formulier laden...</div>`;

    fetch(`/wp-json/vandorp/v1/get_gravity_form/${formId}`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
    })
    .then(response => response.json())
    .then(data => {
        if (data && !data.code) {
            formContainer.innerHTML = data.form_html;

            const event = new Event("gform_post_render");
            window.document.dispatchEvent(event);

            setTimeout(() => {
                updateGravityFormLocation(locationId);
            }, 500);
        } else {
            console.error("[ERROR] Formulier kon niet geladen worden.");
            formContainer.innerHTML = `<p>Formulier kon niet geladen worden.</p>`;
        }
    })
    .catch(error => console.error('Formulier fout:', error));
}

  initializeLocationField();

  window.document.addEventListener('gform_post_render', function () {
    initializeLocationField();
  });
});

function addKeenSliderNavigation(slider) {

  let dots, arrowLeft, arrowRight;

  function markup(remove) {
    arrowMarkup(remove);
  }

  function removeElement(element) {
    element.parentNode.removeChild(element);
  }

  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    const arrowContainerSelector = '.post-slider__arrows';

    let existingArrowContainer = slider.container.parentNode.querySelector(arrowContainerSelector);

    if (remove && existingArrowContainer) {
      removeElement(existingArrowContainer);
      return;
    }

    if (existingArrowContainer) {
      return;
    }

    const arrowContainer = createDiv("post-slider__arrows");

    if (slider.container.classList.contains('is-style-certificates')) {
      arrowContainer.classList.add('arrows-normal');
    }

    arrowLeft = createDiv("post-slider__arrow post-slider__arrow--left icon-chevron-left");
    arrowLeft.setAttribute("role", "button");
    arrowLeft.setAttribute("aria-label", "Previous slide");
    arrowLeft.setAttribute("tabindex", "0");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowLeft.addEventListener("keydown", (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        slider.prev();
      }
    });

    arrowRight = createDiv("post-slider__arrow post-slider__arrow--right icon-chevron-right");
    arrowRight.setAttribute("role", "button");
    arrowRight.setAttribute("aria-label", "Next slide");
    arrowRight.setAttribute("tabindex", "0");
    arrowRight.addEventListener("click", () => slider.next());
    arrowRight.addEventListener("keydown", (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        slider.next();
      }
    });

    arrowContainer.appendChild(arrowLeft);
    arrowContainer.appendChild(arrowRight);

    slider.container.parentNode.insertBefore(arrowContainer, slider.container);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    var totalSlides = slider.track.details.slides.length;
    var slidesPerView = getSlidesPerView();
    var firstSlideDistance = slider.track.details.slides[0].distance;
    var lastSlideDistance = slider.track.details.slides.at(-1).distance;

    slide === 0
      ? arrowLeft.classList.add("post-slider__arrow--disabled")
      : arrowLeft.classList.remove("post-slider__arrow--disabled");
    slide >= totalSlides - slidesPerView
      ? arrowRight.classList.add("post-slider__arrow--disabled")
      : arrowRight.classList.remove("post-slider__arrow--disabled");

    // hide slider arrows if all fit within viewport
    if(firstSlideDistance >= 0 && lastSlideDistance <= 1) {
      arrowLeft.classList.add("post-slider__arrow--hidden")
      arrowRight.classList.add("post-slider__arrow--hidden")
    } else {
      arrowLeft.classList.remove("post-slider__arrow--hidden");
      arrowRight.classList.remove("post-slider__arrow--hidden");
    }

  }

  function getSlidesPerView() {
    return window.innerWidth <= 686 ? 1 : slider.options.slides.perView;
  }

  slider.on("created", () => {
    markup();
    updateClasses();
  });
  slider.on("optionsChanged", () => {
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
  });

  window.addEventListener('resize', () => {
    markup(true);
    markup();
    updateClasses();
  });
}

function initKeenSliders() {
  const isMobile = window.matchMedia("(max-width: 686px)");

  document.querySelectorAll('.keen-slider:not(.theme-slider), .is-style-certificates').forEach((el) => {
    if (!el.classList.contains('keen-slider')) {
      el.classList.add('keen-slider');
    }
    Array.from(el.children).forEach((child) => {
      if (!child.classList.contains('keen-slider__slide')) {
        child.classList.add('keen-slider__slide');
      }
    });

    const hasCertificateClass = el.classList.contains('is-style-certificates');
    const hasNoArrowsClass = el.closest('.no-arrows-slider');
    const slideCount = el.querySelectorAll('.keen-slider__slide').length;

    if (hasNoArrowsClass) {
      if (el.keenSlider) {
        el.keenSlider.destroy();
        el.keenSlider = null;
      }
      return;
    }

    const isCurrentlyMobile = isMobile.matches;

    // Certificaten variant
    if (hasCertificateClass && slideCount <= 5 && !isCurrentlyMobile) {
      if (el.keenSlider) {
        el.keenSlider.destroy();
        el.keenSlider = null;

        const arrowContainer = el.previousElementSibling;
        if (arrowContainer && arrowContainer.classList.contains('post-slider__arrow')) {
          arrowContainer.remove();
        }
      }
      return;
    }
    // End Certificaten variant

    if (el.keenSlider) {
      el.keenSlider.destroy();
      el.keenSlider = null;

      const arrowContainer = el.previousElementSibling;
      if (arrowContainer && arrowContainer.classList.contains('post-jaw')) {
        arrowContainer.remove();
      }
    }

    const columns = hasCertificateClass ? 5 : (el.getAttribute('data-columns') || 4);

    const hasMinimalType = el.querySelector('.type_minimal') !== null;
    const hasWpBlockImage = el.querySelector('.wp-block-image') !== null;

    let mobileView;

    if (hasMinimalType) {
      mobileView = 2;
    } else if (hasCertificateClass) {
      mobileView = 3;
    } else {
      mobileView = hasWpBlockImage ? 1 : (columns == 6 ? 2 : 1);
    }

    let slider = new KeenSlider(el, {
      breakpoints: {
        "(max-width: 686px)": {
          slides: { perView: mobileView, spacing: 20 },
        }
      },
      slides: {
        perView: parseInt(columns),
        spacing: 20,
      },
      initial: 0,
    }, [
      addKeenSliderNavigation,
      (slider) => {
        slider.on("created", () => updateSlideClasses(slider));
        slider.on("slideChanged", () => updateSlideClasses(slider));
      }
    ]);

    el.keenSlider = slider;
  });
}


function updateSlideClasses(slider) {
  const activeIndex = slider.track.details.rel;
  const slides = slider.container.querySelectorAll('.keen-slider__slide');

  slides.forEach((slide, index) => {
    if (index === activeIndex) {
      slide.classList.add('active');
      slide.classList.remove('inactive');
    } else if (index === activeIndex + 1) {
      slide.classList.add('next');
      slide.classList.remove('inactive', 'active');
    } else {
      slide.classList.add('inactive');
      slide.classList.remove('active', 'next');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {

  var showOnMapBtn = document.querySelector('.show_on_map a');
  var facetMap = document.querySelector('.facetwp-facet-map');

  if (showOnMapBtn) {
    var showOnMapDefText = showOnMapBtn.textContent;

    showOnMapBtn.addEventListener('click', (e) => {

      showOnMapBtn.classList.toggle('is-open');
      facetMap.classList.toggle('is-open');

      if (showOnMapBtn.classList.contains("is-open")) {
        showOnMapBtn.textContent = "Toon op kaart";
      } else {
        showOnMapBtn.textContent = showOnMapDefText;
      }

    });
  }

  document.querySelectorAll('.wp-block-vandorp-tabs').forEach((el, i) => {

    var slider = new KeenSlider(
      el.querySelector('.tabs__list'),
      {
        selector: '.wp-block-vandorp-tab',
        loop: false,
        drag: false,
        disabled: true,
        defaultAnimation: {
          duration: 0
        },
        slides: {
          perView: 1,
          spacing: 0
        },
        breakpoints: {
          '(min-width: 922px)': {
            disabled: false
          }
        }
      }
    );

    el.querySelectorAll('.wp-block-vandorp-tab').forEach((tab, i) => {

      const title = tab.getAttribute('data-title');
      const button = '<li><button aria-label="Ga naar tabblad ' + title + '">' + title + '</button></li>';

      el.querySelector('.tabs__nav ul').insertAdjacentHTML('beforeend', button);

      tab.querySelector('.tab__title').onclick = () => {

        tab.classList.toggle('active');

      };

    });

    el.querySelectorAll('.tabs__nav button').forEach((button, i) => {

      button.addEventListener('click', function (e) {

        e.preventDefault();

        // Mark button as active
        el.querySelectorAll('.tabs__nav button').forEach((button, i) => {
          button.classList.remove('active');
        });
        button.classList.add('active');

        slider.moveToIdx(i);

        // Mark slide as active
        slider.slides.forEach((slide, i) => {
          slide.classList.remove('active');
        });
        slider.slides?.[i]?.classList.add('active');

      }, { passive: false });
    });

    el.querySelectorAll('.wp-block-vandorp-tab')[0].classList.add('active');
    el.querySelectorAll('.tabs__nav button')[0].classList.add('active');
  });

  const safeMenu = initSafeMenuTriangle('horizontal');

  document.querySelectorAll('#masthead .has-extended-mega-menu .astra-full-megamenu-wrapper > ul > li > ul > li').forEach((el, i) => {
    el.querySelector('.astra-megamenu .menu-link').addEventListener('mouseenter', function (e) {
      safeMenu.enableSafeTriangle(el);
      el.parentNode.style.minHeight = el.querySelector('.mega-menu-extended-content').offsetHeight + 'px';
    });

    el.onmouseleave = () => {
      safeMenu.disableSafeTriangle(el);
    }

    el.querySelector('.astra-megamenu .menu-link').onmousemove = (e) => {
      safeMenu.updateSafeTriangle(el, e);
    }
  });


});


function initAnimations() {
  const revealingElements = [
    '.wp-block-vandorp-number',
    '#content .wp-block-group.alignfull',
    '.wp-block-vandorp-timeline .timeline > div'
  ];

  const staggeringRevealingElements = [
    {
      class: '.item',
      parent: '.wp-block-vandorp-post-grid:not(.wp-block-vandorp-post-grid--layout-slider), .wp-block-vandorp-filter-grid',
      delay: 0.05
    },
    {
      class: '.wp-block-image',
      parent: '.wp-block-gallery.is-style-certificates',
      delay: 0.05
    }
  ];

  const isInViewport = el => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0
    );
  };

  const observer = new IntersectionObserver(
    entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('vandorp-reveal');
      }
    }),
    { threshold: 0 }
  );

  const handleElement = el => {
    if (isInViewport(el)) {
      el.classList.add('vandorp-reveal');
    } else {
      el.classList.add('vandorp-animate');
      observer.observe(el);
    }
  };

  revealingElements.forEach(selector =>
    document.querySelectorAll(selector).forEach(handleElement)
  );

  staggeringRevealingElements.forEach(({ class: className, parent, delay }) => {
    document.querySelectorAll(parent).forEach(parentEl => {
      parentEl.querySelectorAll(className).forEach((el, index) => {
        if (!isInViewport(el)) {
          el.style.transitionDelay = `${index * delay}s`;
          el.classList.add('vandorp-animate');
          observer.observe(el);
        } else {
          el.classList.add('vandorp-reveal');
        }
      });
    });
  });
}

// MEGAMENU
function initSafeMenuTriangle(type = 'vertical') {

  let lastPosition = false;
  let timeoutId;

  /*
   * Create a triangle element and append it to the menu link
   */
  function createSafeTriangle(el) {
    const triangle = document.createElement('div');
    triangle.classList.add('menu-link__safe-triangle');
    if (type === 'horizontal') {
      triangle.style.clipPath = 'polygon(100% 0, 0 50%, 100% 100%)';
    } else {
      triangle.style.clipPath = 'polygon(50% 0, 0 100%, 100% 100%)';
    }
    el.querySelector('.menu-link').appendChild(triangle);
    triangle.addEventListener('mousedown', function (e) {
      if (e.button !== 1) return;

      e.preventDefault();
      triangle.style.pointerEvents = 'none';
      var target = document.elementFromPoint(e.clientX, e.clientY);
      if (target && target.classList.contains('menu-link')) {
        target.click();
      }
      setTimeout(function () {
        triangle.style.pointerEvents = 'auto';
      }, 30);
    }, { passive: false });
  }

  /*
   * Enable the safe triangle for a menu link
   */
  function enableSafeTriangle(el) {

    // If there's no safe triangle, create one
    if (!el.querySelector('.menu-link__safe-triangle')) {
      createSafeTriangle(el);
    }

    // Set the safe triangle initial shape and position
    if (type === 'horizontal') {
      el.querySelector('.menu-link__safe-triangle').style.clipPath = 'polygon(100% 0, 0 50%, 100% 100%)';
    } else {
      var submenu = el.querySelector('.astra-megamenu') || el.querySelector('.sub-menu');
      var isMegaMenu = !!el.querySelector('.astra-megamenu');
      el.querySelector('.menu-link__safe-triangle').style.clipPath = 'polygon(50% 0, 0 100%, 100% 100%)';
      el.querySelector('.menu-link__safe-triangle').style.width = submenu.offsetWidth + 'px';
      el.querySelector('.menu-link__safe-triangle').style.left = isMegaMenu ? document.querySelector('.site-primary-header-wrap').getBoundingClientRect().left + 'px' : (submenu.getBoundingClientRect().left - el.getBoundingClientRect().left) + 'px';
    }

    // Show the safe triangle
    el.querySelector('.menu-link__safe-triangle').style.display = 'block';
  }

  /*
   * Disable the safe triangle for a menu link
   */
  function disableSafeTriangle(el) {
    lastPosition = false;
    el.querySelector('.menu-link__safe-triangle').style.display = 'none';
  }

  /*
   * Update the safe triangle position based on the mouse position
   */
  function updateSafeTriangle(el, e) {
    enableSafeTriangle(el);

    var triangle = el.querySelector('.menu-link__safe-triangle');
    if (!triangle) {
      return;
    }

    var x, y;

    var parentElement = el.closest('.menu-item-has-children');
    if (!parentElement) {
      return;
    }

    if (type === 'horizontal') {
      let offsetX = 1;
      let menuWidth = triangle.offsetWidth;
  
      x = ((e.clientX - el.getBoundingClientRect().left - offsetX) / menuWidth) * 100;
      y = ((e.clientY - parentElement.getBoundingClientRect().top) / parentElement.offsetHeight) * 100;
  
      triangle.style.clipPath = `polygon(100% 0, ${x}% ${y}%, 100% 100%)`;
      lastPosition = updateLastPosition(lastPosition, x, el);
    } else {
      var submenu = el.querySelector('.astra-megamenu .sub-menu') || el.querySelector('.sub-menu');
      if (!submenu) {
          return;
      }
  
      let offsetX = 1;
      let submenuWidth = submenu.offsetWidth;
  
      x = ((e.clientX - submenu.getBoundingClientRect().left - offsetX) / submenuWidth) * 100;
      y = ((e.clientY - parentElement.getBoundingClientRect().top) / parentElement.offsetHeight) * 100;
  
      triangle.style.clipPath = `polygon(${x}% ${(y - 5)}%, 0% 100%, 100% 100%)`;
      lastPosition = updateLastPosition(lastPosition, y, el);
    }
  

    clearTimeout(timeoutId);
    timeoutId = setDeactivationTimeout(lastPosition, e, el);
  }

  /*
   * Update the last position of the safe triangle
   */
  function updateLastPosition(lastPosition, currentPosition, el) {
    if (lastPosition && currentPosition < lastPosition) {
      disableSafeTriangle(el);
      return false;
    }
    return currentPosition;
  }

  /*
   * Set a timeout to deactivate the safe triangle when the mouse stops moving
   */
  function setDeactivationTimeout(lastPosition, e, el) {
    return setTimeout(() => {
      if (lastPosition == (type === 'horizontal' ? (e.clientX - el.getBoundingClientRect().left) / el.offsetWidth * 400 : (e.clientY - el.parentElement.getBoundingClientRect().top) / el.parentElement.offsetHeight * 100)) {
        disableSafeTriangle(el);
        var mouseX = e.clientX;
        var mouseY = e.clientY;
        var target = document.elementFromPoint(mouseX, mouseY);
        if (target && target.classList.contains('menu-link')) {
          target.onmouseenter(target);
        }
      }
    }, 30);
  }

  return { enableSafeTriangle, disableSafeTriangle, updateSafeTriangle };
}

